/**
 * Client-side image compression.
 * Resizes very large images to MAX_SIDE (longest dimension) and re-encodes
 * as JPEG at quality 0.85. Returns a base64 data URL.
 * This prevents the browser from holding multi-MB strings in React state
 * and makes uploads fast over slow Algerian connections.
 */
const MAX_SIDE = 1600;
const QUALITY = 0.85;

export const compressImageFile = (file) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Image decode failed'));
      img.onload = () => {
        try {
          let { width, height } = img;
          if (width > MAX_SIDE || height > MAX_SIDE) {
            if (width >= height) {
              height = Math.round((height * MAX_SIDE) / width);
              width = MAX_SIDE;
            } else {
              width = Math.round((width * MAX_SIDE) / height);
              height = MAX_SIDE;
            }
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL('image/jpeg', QUALITY);
          resolve(dataUrl);
        } catch (e) {
          reject(e);
        }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });

export default compressImageFile;
